import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { storeService } from '../services/storeService';
import { StoreCategory } from '../models';
import { Hero } from '../components/home/Hero';
import { CategoryGrid } from '../components/home/CategoryGrid';
import { HomeBanners } from '../components/home/HomeBanners';
import { TrustStrip } from '../components/home/TrustStrip';
import { AudienceFinder } from '../components/home/AudienceFinder';
import { CategoryShowcase } from '../components/home/CategoryShowcase';
import { NewArrivals } from '../components/home/NewArrivals';
import { BestSellers } from '../components/home/BestSellers';
import { CollectionsCarousel } from '../components/home/CollectionsCarousel';
import { ShopBySize } from '../components/home/ShopBySize';
import { InstagramShowcase } from '../components/home/InstagramShowcase';
import { SocialProof } from '../components/home/SocialProof';
import { useInitEffect } from '../hooks/useInitEffect';

const GENDER_FEMININO = 2;
const GENDER_MASCULINO = 1;

export function HomePage() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<StoreCategory[]>([]);

  useInitEffect(() => {
    storeService.getCategories().then(setCategories).catch(() => {});
  });

  const handleFinderSelectGirls = () => {
    navigate(`/catalogo?gender=${GENDER_FEMININO}`);
  };

  const handleFinderSelectBoys = () => {
    navigate(`/catalogo?gender=${GENDER_MASCULINO}`);
  };

  const handleFinderSelectAccessories = () => {
    const accessoryCategory = categories.find((c) => /acess[oó]rio/i.test(c.name));
    navigate(accessoryCategory ? `/catalogo?cat=${accessoryCategory.id}` : '/catalogo');
  };

  const handleCollectionSelect = (collectionId: number) => {
    navigate(`/catalogo?col=${collectionId}`);
  };

  const handleShopBySizeSelect = (variationValues: string[]) => {
    navigate(`/catalogo?var=${variationValues.join(',')}`);
  };

  return (
    <>
      <Hero />
      <CategoryGrid />
      <CategoryShowcase />
      <TrustStrip />
      <HomeBanners onSelectCollection={handleCollectionSelect} />
      <NewArrivals />
      <BestSellers />
      <ShopBySize onSelectSize={handleShopBySizeSelect} />
      <AudienceFinder
        onSelectGirls={handleFinderSelectGirls}
        onSelectBoys={handleFinderSelectBoys}
        onSelectAccessories={handleFinderSelectAccessories}
      />
      <SocialProof />
      <InstagramShowcase />
      <CollectionsCarousel onSelectCollection={handleCollectionSelect} />
    </>
  );
}
